import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import { latestPosts } from "@/lib/blogPosts";

export default function FromBlog() {
  const posts = latestPosts(3);
  if (!posts.length) return null;
  return (
    <section data-testid="from-blog" className="py-16 md:py-24 bg-soft-blue">
      <div className="container-x">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div className="max-w-2xl">
            <h2 className="text-[32px] md:text-[44px] font-extrabold text-navy">From our Health Blog</h2>
            <p className="mt-3 text-ink/85">Practical home-care guides written by our nurses for worried families.</p>
          </div>
          <Link to="/blog" className="inline-flex items-center gap-1.5 text-brand font-bold hover:gap-2.5 transition-all">All articles <ArrowRight className="w-4 h-4" /></Link>
        </div>
        <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-5">
          {posts.map((p) => (
            <Link key={p.slug} data-testid={`home-blog-${p.slug}`} to={`/blog/${p.slug}`} className="bg-white rounded-2xl border border-navy/10 overflow-hidden hover-care flex flex-col">
              <div className="aspect-[16/10] bg-white"><img src={p.image} alt={p.alt} loading="lazy" className="w-full h-full object-cover" /></div>
              <div className="p-5 flex-1 flex flex-col">
                <span className="inline-flex w-fit px-2.5 py-1 rounded-full bg-mint text-care text-[11px] font-bold uppercase tracking-widest">{p.category}</span>
                <h3 className="mt-3 text-[17px] font-bold text-navy leading-snug">{p.title}</h3>
                <div className="mt-auto pt-4 flex items-center gap-2 text-[12.5px] text-ink/55"><Clock className="w-3.5 h-3.5" /> {p.readMins} min read</div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
